<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="'数据指标-'+modalData.initName"
        :show-close="false"
        width="550px"
        append-to-body
        :before-close="handleClose">
        <div>
            <el-form  ref="form" :model="formItem" :rules="rules" label-width="100px" class="pr40" :disabled="modalData['type'] == 'info'">
                <el-form-item label="名称" prop="display_name">
                    <el-input v-model.trim="formItem.display_name" maxlength="20" show-word-limit placeholder="请输入账户名称"
                        style="width:230px;" clearable @keydown.native.prevent.enter="handleSubmit" />
                </el-form-item>
                <el-form-item></el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "TargetModal",
        components: {},
        props: {
            modalData:{  
                type:Object, 
                required:true,
            },
            shownField:{
                type:Array,
                required: true,
            },
            hiddenField:{
                type:Array,
                required: true,
            },
            targets:{ 
                type:Array,   // 选中指标
                required: true,
            },
            allField:{
                type:Array,  //所有指标
                required: true,
            },
            platId:[String,Number],
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            isCompare:{
                required: false,
                type:Boolean,
                default:false,
            },
            allDimensions: {
                type:Array,  //维度
                required: true,
            },
            selectDimensions: {
                type:Array,  //选中维度
                required: true,
            }
            // dimensions
        },
        data() {
            return {
                dialogVisible: false,
                formItem: {
                    display_name: '' // 维度名称
                },
                rules: {
                    display_name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                },
                dimensionList:[],
                createDimensionList:[],
                yyTypeDimensionList:[],
                allFieldList:[],
                lastSelectVal:'',
            }
        },
        computed: {
            availableFieldList(){
                if(!this.isTimeFilter) return this.allFieldList;
                if(this.isCompare&&!this.isTimeFilter){
                    return this.allFieldList;
                }
                return this.allFieldList.filter(field=>((field.config||{}).time_type||[]).includes('hour'));
            },
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.$nextTick(()=>{
                    this.resetForm();
                })
            },
            resetForm() {
                this.formItem.display_name = ''
                this.$refs['form'].resetFields();
            },
            makeDimensionList(){
                if(this.platId=='3'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_name',
                        },
                        {
                            display_name:'按创意',
                            name:'idea_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'idea_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按广告',
                        },
                        {
                            name:'idea_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='4'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按任务',
                            name:'task_name',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按任务',
                            name:'task_create_date',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_yy_type',
                        },
                        {
                            display_name:'按客户',
                            name:'company_yy_type',
                        },
                        {
                            display_name:'按账户',
                            name:'account_yy_type',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            display_name:'按产品',
                            name:'app_yy_type',
                        },
                        {
                            display_name:'按任务',
                            name:'task_yy_type',
                        },
                        {
                            display_name:'按子任务',
                            name:'sub_task_yy_type',
                        },
                    ];
                }else if(this.platId=='8'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按广告系列',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];

                } else if(this.platId=='9'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按广告系列组',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword',
                        },
                        {
                            display_name:'按搜索词',
                            name:'search_term',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_name',
                        },
                    ].filter(item=>{
                        if(this.isTimeFilter){
                            return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                        }else{
                            return true;
                        }
                    });
                    this.createDimensionList = [
                        {
                            display_name:'按广告系列',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword_create_date',
                        },
                        {
                            display_name:'按广告',
                            name:'ad_create_date',
                        },
                    ].filter(item=>{
                        if(this.isTimeFilter){
                            return item.name!='search_term'&&item.name!='ad_name'&&item.name!='ad_create_date';
                        }else{
                            return true;
                        }
                    });
                    this.yyTypeDimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_yy_type',
                        },
                        {
                            display_name:'按客户',
                            name:'company_yy_type',
                        },
                        {
                            display_name:'按广告系列组',
                            name:'account_yy_type',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            display_name:'按产品',
                            name:'app_yy_type',
                        },
                        {
                            display_name:'按广告系列',
                            name:'plan_yy_type',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_yy_type',
                        },
                        {
                            display_name:'按关键词',
                            name:'keyword_yy_type',
                        },
                    ];
                }else if(this.platId=='7'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'project_yy_type',
                            display_name:'按项目',
                        },
                        {
                            name:'subproject_yy_type',
                            display_name:'按推广',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else if(this.platId=='12'){
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }else{
                    this.dimensionList = [
                        {
                            display_name:'按集团',
                            name:'bloc_name',
                        },
                        {
                            display_name:'按客户',
                            name:'company_name',
                        },
                        {
                            display_name:'按账户',
                            name:'account_name',
                        },
                        {
                            display_name:'按项目',
                            name:'project_name',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_name',
                        },
                        {
                            display_name:'按产品',
                            name:'app_name',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_name',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_name',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_name',
                        },
                    ];
                    this.createDimensionList = [
                        {
                            display_name:'按账户',
                            name:'account_create_time',
                        },
                        {
                            display_name:'按计划',
                            name:'plan_create_date',
                        },
                        {
                            display_name:'按广告组',
                            name:'adgroup_create_date',
                        },
                        {
                            display_name:'按创意',
                            name:'ad_create_date',
                        },
                    ];
                    this.yyTypeDimensionList = [
                        {
                            name:'bloc_yy_type',
                            display_name:'按集团',
                        },
                        {
                            name:'company_yy_type',
                            display_name:'按客户',
                        },
                        {
                            name:'account_yy_type',
                            display_name:'按账户',
                        },
                        {
                            display_name:'按项目',
                            name:'project_yy_type',
                        },
                        {
                            display_name:'按推广',
                            name:'subproject_yy_type',
                        },
                        {
                            name:'app_yy_type',
                            display_name:'按产品',
                        },
                        {
                            name:'plan_yy_type',
                            display_name:'按计划',
                        },
                        {
                            name:'adgroup_yy_type',
                            display_name:'按广告组',
                        },
                        {
                            name:'ad_yy_type',
                            display_name:'按创意',
                        },
                    ];
                }
            },
            showModal() {
                this.dialogVisible = true;
                this.makeDimensionList();


                this.formItem.display_name = this.modalData.display_name||'';

                if(this.modalData.name=='start_date'){
                    this.lastSelectVal = this.formItem.start_date_dimension;
                }else if(this.modalData.name=='create_date'){
                    this.lastSelectVal = this.formItem.create_date_dimension;
                }else if(this.modalData.name=='yy_type'){
                    this.lastSelectVal = this.formItem.yy_type_dimension;
                }


                this.$nextTick(()=>{
                    let checkedData = []
                    let flatData = [];
                    this.allField.forEach(item => {
                        if (item.children && item.children.length > 0) {
                            flatData = flatData.concat(item.children.map(inner=>{
                                if(item.name.includes('_sum_data')){
                                    inner.isSumField = true;
                                }
                                return inner;
                            }));
                        }
                    });

                    flatData.forEach(item=>{
                        if(checkedData.findIndex(inner=>inner.name==item.name)===-1){
                            checkedData.push(item);
                        }
                    });
                    this.allFieldList = checkedData;
                })
            },
            handleSubmit() {

                if(this.modalData && this.modalData['type'] == 'info') {
                    this.$nextTick(()=>{
                        this.handleClose();
                    })
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        //全部维度
                        let is_equal_all_dimensions = this.allDimensions.some(item=>{
                            let r_boolean = false
                            item['children'] && item['children'].forEach(el=>{
                                if(el['display_name'] == this.formItem.display_name) {
                                    r_boolean = true
                                }
                            })
                            return r_boolean
                        })
                        //选中维度
                        let is_equal_select_dimensions = this.selectDimensions.some(item=>{
                            if(item['display_name'] == this.formItem.display_name) {
                                return true
                            }
                        })
                        //全部指标
                        let is_equal_all_target = this.allFieldList.some(item=>{
                            let r_boolean = false
                            item['children'] && item['children'].forEach(el=>{
                                if(el['name'] != this.modalData['name'] && el['display_name'] == this.formItem.display_name) {
                                    r_boolean = true
                                }
                            })
                            return r_boolean
                        })
                        //选中指标
                        let is_equal_select_target = this.targets.filter(item=>item['name'] != this.modalData['name']).some(item=>item['display_name'] == this.formItem.display_name)

                        // console.log('全部维度', is_equal_all_dimensions)
                        // console.log('选中维度', is_equal_select_dimensions)
                        // console.log('全部维度', is_equal_all_target)
                        // console.log('选中维度', is_equal_select_target)

                        if(is_equal_all_dimensions || is_equal_select_dimensions || is_equal_all_target || is_equal_select_target){
                            return this.$message.error('名称重复，请修改');
                        }

                        if(this.formItem.display_name == ''){
                            return this.$message.error('名称必填项，不可为空');
                        }


                        let data={
                            name: this.modalData['name'],
                            // display_name: this.modalData['display_name'],
                            display_name: this.formItem.display_name
                 
                        };
                        console.log('data', data)
                        this.$emit('save-value', data);
                        this.$nextTick(()=>{
                            this.handleClose();
                        })
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

</style>
